import React from 'react';
import styled from 'styled-components';
import { Link, useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import Contact from '../landing/contact';

const FooterWrapper = styled.footer`
  background: ${({ theme, contactShow }) =>
    contactShow ? theme.color.backgroundGrayHome : theme.color.grayBlack};
  padding: 50px 35px;
  box-shadow: inset 0 1px 0 #e0e0e0;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    padding: 20px 35px 20px 35px;
    display: block;
  }
`;
const LogoWrapper = styled.div`
  display: flex;

  &.left {
    justify-content: start;
    padding: 0 0 0 5%;
    width: 33%;

    @media screen and (max-width: 1440px) {
      justify-content: start;
      padding: 0 0 0 6%;
      width: 30%;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.laptop}) {
      justify-content: start;
      padding: 0 0 0 2%;
      width: 50%;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
      padding: 0;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
      justify-content: center;
      padding: 0;
      width: 100%;
    }

    @media screen and (min-width: 2000px) {
      justify-content: start;
      padding: 0 0 0 8%;
      width: 33%;
    }
  }
  &.middle {
    width: 33%;
    justify-content: center;
    padding-left: 6%;

    @media screen and (max-width: ${({ theme }) => theme.device.laptop}) {
      justify-content: flex-end;
      padding: 0 2% 0 0;
      width: 50%;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
      width: 100%;
      padding: 0px;
      justify-content: center;
    }
  }
  &.right {
    justify-content: flex-end;
    padding: 0 2% 0 0;
    width: 33%;

    @media screen and (max-width: ${({ theme }) => theme.device.laptop}) {
      justify-content: center;
      padding: 37px 0 0 3%;
      width: 100%;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
      justify-content: center;
      width: 100%;
      padding: 0px;
      &.left {
        width: 100%;
      }
      &.middle {
        width: 100%;
      }
      &.right {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    width: 100%;
    margin: 25px 0;
  }
`;
const CustomLogo = styled(Img)`
  width: 50px;
  vertical-align: middle;
  filter: brightness(0.7);
  margin-right: 8px;
`;

const FooterText = styled.span`
  ${({ theme }) => theme.typography.footerContent()};
  position: relative;
  color: ${({ theme }) => theme.color.textFooter};
  vertical-align: middle;
`;

const PrivacyWrapper = styled(Link)`
  ${({ theme }) => theme.typography.footerContent()};
  color: ${({ theme }) => theme.color.textFooter};
  vertical-align: middle;
  text-decoration: none;
  margin: auto 6px;
  text-transform: uppercase;
`;

const CopyrightWrapper = styled.span`
  ${({ theme }) => theme.typography.footerContent()};
  color: ${({ theme }) => theme.color.textFooter};
  vertical-align: middle;

  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    float: none;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    width: 100%;
  }
`;

const FadeFooterStyle = styled.div`
  position: absolute;
  z-index: 0;
  left: 180px;
  top: -200px;
  height: 1687px;
  width: 1800px;

  background: radial-gradient(
    38.84% 50% at 50% 50%,
    rgba(67, 175, 220, 0.28) 0%,
    rgba(67, 175, 220, 0) 96.88%,
    rgba(161, 52, 234, 0) 100%
  );

  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    left: -651px;
    right: 0;
    top: -14.03%;
    bottom: -117.51%;
  }

  @media (min-width: 1780px) {
    left: 500px;
  }
  @media (min-width: 2000px) {
    left: 900px;
  }
`;

const Footer = ({ contactShow = true }) => {
  const BackgroundFooterColor = styled.div`
    position: relative;
    overflow: hidden;
    z-index: 10;
  `;

  const logo = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "logo-footer.png" }) {
        childImageSharp {
          fixed(width: 50, quality: 60) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `);

  return (
    <div
      css={`
        position: relative;
        background-color: ${({ theme }) => theme.color.backgroundGrayHome};
      `}
    >
      <BackgroundFooterColor>
        {!!contactShow && <FadeFooterStyle />}
        {!!contactShow && <Contact />}
        <FooterWrapper contactShow={contactShow}>
          <LogoWrapper className="left">
            <FooterText>
              <CustomLogo fixed={logo.file.childImageSharp.fixed} />
              ein Unternehmen der 20Scoops
            </FooterText>
          </LogoWrapper>
          <LogoWrapper className="middle">
            <FooterText>
              <PrivacyWrapper to={'/imprint'}>IMPRESSUM</PrivacyWrapper>/
              <PrivacyWrapper to={'/privacy'}>DATENCHUTZ</PrivacyWrapper>
            </FooterText>
          </LogoWrapper>
          <LogoWrapper className="right">
            <CopyrightWrapper>
              © {new Date().getFullYear()} 20IT. All Rights Reserved
            </CopyrightWrapper>
          </LogoWrapper>
        </FooterWrapper>
      </BackgroundFooterColor>
    </div>
  );
};

export default Footer;
